import { combineReducers } from "redux";

import posts from "./posts";

// exports all reducers from posts reducers file
export const reducers = combineReducers({ posts });
